import type { ModalEntries } from '@vnetwork/datacentral-shell/host'

// The module's modals, registered with the host by createDayoffsModule (#204).
// require.context cannot see packages/, so they are declared here, one entry
// per modal, under the keys setModal('<Group>/<Modal>/index') has always used.
// check:modal-keys reads this file: keep every entry as
// '<key>': () => import('<relative path>').
export const dayoffsModals = {
    'DayOffModals/ApproveMultipleDayOffModal/index': () =>
        import('./modals/DayOffModals/ApproveMultipleDayOffModal'),
    'DayOffModals/BomConfirmModal/index': () =>
        import('./modals/DayOffModals/BomConfirmModal'),
    'DayOffModals/LeaderConfirmModal/index': () =>
        import('./modals/DayOffModals/LeaderConfirmModal'),
    'DayOffModals/RejectModal/index': () =>
        import('./modals/DayOffModals/RejectModal'),
} satisfies ModalEntries
